import dynamic from "next/dynamic";
const ElectionLanding = dynamic(() => import("@/screens/FiveStateElection/ElectionLanding"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import useIsMobile from "@/hooks/useIsMobile";
// import CategoryPage from "@/screens/Category";
// import PageLayout from "@/screens/Layout/PageLayout";

export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
}) {
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionLanding
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          masterKey="assembly_widgets_2026"
          stateHindi=""
          staticContent=""

        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  try {
    let url = ctx?.resolvedUrl;

    // redirection

    //* remove query param from url
    url = url.split("?")[0];

    const { getDataByUrl, getNewUrlByOldSef } = await import(
      "@/handlers/commonApi"
    );
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "all",
      },
    });
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let [categoryNewsListData, latestStoryData, latestVideoData] =
      await Promise.all([
        fetchRedisWrapper(categoryListRedisKey, () =>
          getDataByUrl({
            url: url,
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(latestStoryRedisKey, () =>
          getLatestContentFeed({
            type: "story",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(latestVideoRedisKey, () =>
          getLatestContentFeed({
            type: "video",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
      ]);

    // if (
    //   !categoryNewsListData ||
    //   Object.keys(categoryNewsListData).length === 0
    // ) {
    //   let sefUrl = ctx?.params?.category;
    //   console.log("##Find Article By SefURL##", sefUrl);
    //   const redirectUrlRedisKey = getRedisApiKey({
    //     masterConfigData: masterConfigData,
    //     redisPrefix: "PREFIX_REDIS_ROS",
    //     params: {
    //       api: "getnewurl",
    //       sefUrl: sefUrl,
    //     },
    //   });
    //   let responseData = await fetchRedisWrapper(redirectUrlRedisKey, () =>
    //     getNewUrlByOldSef({ sefUrl })
    //   );
    //   // console.log("res", responseData);
    //   if (responseData?.url) {
    //     let url = new URL(responseData.url); //? extract pathname from url with query params from url
    //     let pathname = url.pathname;

    //     let headerCache = responseData?.cache;
    //     setPageTTL(ctx, headerCache?.akamai_ttl);
    //     return {
    //       redirect: {
    //         destination: `${process.env.NEXT_PUBLIC_WEBSITE_URL}` + pathname,
    //         statusCode: 301,
    //       },
    //     };
    //   } else {
    //     return {
    //       notFound: true,
    //     };
    //   }
    // }

    let headerCache = categoryNewsListData?.cache;
    // setPageTTL(ctx, headerCache?.akamai_ttl);
    setPageTTL(ctx, 120);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
